export type ApiEndpoint<TRequestBody = void, TResponseBody = void> = {
	url: string,
	request?: TRequestBody,
	response?: TResponseBody
}

export type RequestBody<TApiEndPoint> = TApiEndPoint extends { request?: infer TRequestBody } ? Exclude<TRequestBody, undefined> : never;
export type ResponseBody<TApiEndPoint> = TApiEndPoint extends { response?: infer TResponseBody } ? Exclude<TResponseBody, undefined> : never;

export function declareEndpoint<TRequestBody, TResponseBody>(url: string): ApiEndpoint<TRequestBody, TResponseBody> {
	return { url };
}
